const getCart = async () => {
  const cart = await fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const cartJson = await cart.json();
  return cartJson;
};

export { getCart };
